import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface ProductDatatableApiProps extends CacheProps {
  limit?: number;

  page?: number;

  sort?: string;

  brandIds?: Array<string>

  categoryIds?: Array<string>

  title?: string
}

const getProductDatatableApi = async ({ limit = 20, page = 1, sort = 'most_visited', brandIds = [], categoryIds = [], title, ...rest }: ProductDatatableApiProps) => {
  const response = await fetchApi({
    method: 'GET',
    URL: {
      pathname: routes['api.products.datatable'],
      query: {
        limit: limit,
        page: page,
        sort: sort,
        'brand_ids[]': brandIds,
        'category_ids[]': categoryIds,
        title: title,
      },
    },
    ...rest,
  });

  return response?.data;
};

export default getProductDatatableApi;
